var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 7.22222V11.8889C15 13.6071 13.6071 15 11.8889 15H4.11111C2.39289 15 1 13.6071 1 11.8889V4.11111C1 2.39289 2.39289 1 4.11111 1H8.77778",
    stroke: "#4C4C4C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6064 1.41065C12.8693 1.14772 13.226 1 13.5977 1C13.9696 1 14.3263 1.14772 14.5892 1.41065C14.8521 1.67359 14.9998 2.03021 14.9998 2.40206C14.9998 2.77392 14.8521 3.13054 14.5892 3.39347L8.31025 9.67238L5.6665 10.3333L6.32744 7.68959L12.6064 1.41065Z",
    stroke: "#4C4C4C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.1113 3.33325L12.6669 4.88881",
    stroke: "#4C4C4C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditQuery);
export default __webpack_public_path__ + "static/media/EditQuery.4ed15a2076f56c11a85465742bbc9ab5.svg";
export { ForwardRef as ReactComponent };